import { useMemo } from 'react'
import type { StaticTextMap } from '../types'
import getText from './static-text-utils'
import { SYSTEM_PLAYLIST_RESERVED_KEYS } from './playlist-name-utils'

/**
 * Returns a memoized, lower-cased Set of the four system-playlist
 * display names in the user's current locale (with English fallback
 * when a translation is missing — Smartling-lag friendly).
 *
 * Pair with `resolveNonCollidingPlaylistName` from `playlist-name-utils`.
 */
export default function useReservedSystemPlaylistNames (
  staticText: StaticTextMap,
): ReadonlySet<string> {
  return useMemo(() => {
    const out = new Set<string>()
    SYSTEM_PLAYLIST_RESERVED_KEYS.forEach(({ key, fallback }) => {
      const label = getText(staticText, key, fallback)
      if (label) out.add(label.trim().toLowerCase())
    })
    return out
  }, [staticText])
}
